import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { ChatBot } from '../ui/ChatBot';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
};

export default Layout;
